import "core-js/modules/es6.number.constructor.js";
export default {
  props: {
    ratio: [String, Number]
  },
  computed: {
    ratioStyle: function ratioStyle() {
      var ratio = this.ratio || this.naturalRatio;
      if (ratio !== void 0) {
        return {
          paddingBottom: "".concat(100 / ratio, "%")
        };
      }
    }
  }
};